export const formatMoney = (tutar) => {
  return (tutar || 0).toLocaleString('tr-TR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }) + ' TRY';
};
/**
 * Elle girilen TL tutarını oku — Türkçe yazım ("26.589,60") ve telefonun NOKTALI sayı klavyesi ("26589.60") birlikte.
 *
 * 2026-10-09: araç satışında okuma "bütün noktaları sil, virgülü ondalık yap"tı; telefonun klavyesinde virgül yoksa
 * personel "26589.60" yazıyor, nokta binlik sayılıp siliniyor → 2.658.960 ₺ kaydedildi (ATH-20261009-0008).
 * Kural: hem nokta hem virgül varsa SONDAKİ ondalıktır. Tek tür ayırıcı varsa: bir tane ve ardından 3 hane DEĞİLSE
 * ondalık ("26589.60", "26589,6"); ardından hep 3'er hane geliyorsa binlik ("26.589", "1.250.000").
 * Geçersizse NaN.
 */
export const tutarOku = (v) => {
  if (typeof v === 'number') return Number.isFinite(v) ? v : NaN;
  let s = String(v ?? '').replace(/[^\d.,-]/g, '');
  if (!/\d/.test(s)) return NaN;
  const sonNokta = s.lastIndexOf('.');
  const sonVirgul = s.lastIndexOf(',');
  if (sonNokta >= 0 && sonVirgul >= 0) {
    const ondalik = sonNokta > sonVirgul ? '.' : ',';
    s = s.split(ondalik === '.' ? ',' : '.').join('').replace(ondalik, '.');
  } else if (sonNokta >= 0 || sonVirgul >= 0) {
    const parca = s.split(sonNokta >= 0 ? '.' : ',');
    const son = parca[parca.length - 1];
    if (parca.length === 2 && son.length !== 3) s = `${parca[0]}.${son}`;
    else if (parca.slice(1).every((p) => p.length === 3)) s = parca.join('');
    else s = `${parca.slice(0, -1).join('')}.${son}`;
  }
  const n = parseFloat(s);
  return Number.isFinite(n) ? n : NaN;
};

/** 26589.6 → "26.589,60 ₺" */
export const tlYaz = (n) => `${(Number(n) || 0).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ₺`;
